import { render, staticRenderFns } from "./IntegrationChip.vue?vue&type=template&id=7005098a&scoped=true&"
import script from "./IntegrationChip.vue?vue&type=script&lang=js&"
export * from "./IntegrationChip.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationChip.vue?vue&type=style&index=0&id=7005098a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7005098a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
